// src/components/project/ProjectHeader.js

const ProjectHeader = ({ project }) => {
  if (!project) return null;

  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <h1>Аналитика проекта "{project.name_text || project.name}"</h1>

      {/* Используем поле `active` (boolean) */}
      <span
        className={`badge ${
          project.active ? 'bg-success' : 'bg-secondary'
        }`}
        style={{ fontSize: '1rem', padding: '0.5em 0.8em' }}
      >
        {project.active ? 'Активен' : 'Архив'}
      </span>
    </div>
  );
};

export default ProjectHeader;


